import { render } from "./UnusedLeaveApprovals.vue?vue&type=template&id=46c89c13&scoped=true"
import script from "./UnusedLeaveApprovals.vue?vue&type=script&lang=js"
export * from "./UnusedLeaveApprovals.vue?vue&type=script&lang=js"

import "./UnusedLeaveApprovals.vue?vue&type=style&index=0&id=46c89c13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c89c13"]])

export default __exports__